type ComponentPropertyDefinition = {
  defaultValue?: unknown;
  type?: string;
  variantOptions?: unknown;
};

export const getComponentPropertyDefinitions = (layer: {
  componentPropertyDefinitions?: Record<string, ComponentPropertyDefinition>;
}) => {
  if (!layer.componentPropertyDefinitions) {
    return [];
  }

  const properties: {
    key: string;
    defaultValue: unknown;
    type: string | undefined;
    variantOptions: unknown;
  }[] = [];

  for (const [propertyKey, property] of Object.entries(
    layer.componentPropertyDefinitions,
  )) {
    properties.push({
      key: propertyKey.split('#')[0],
      defaultValue: property.defaultValue,
      type: property.type,
      variantOptions: property.variantOptions,
    });
  }

  return properties;
};
